<h3 mat-dialog-title>Site Under Maintenance</h3>

<mat-dialog-content class="small-content">
    <p>PayHOA is currently offline for some scheduled maintenance. We'll be back soon!</p>
</mat-dialog-content>
<mat-dialog-actions class="justify-content-end">
    <button [attr.aria-label]="'confirm'" (click)="retry()" class="btn btn-primary">Retry</button>
</mat-dialog-actions>
